import React from 'react';

export type EmailMessageAction = 'reply' | 'reply-all' | 'forward' | 'move' | 'delete' | 'mark-unread';

interface EmailMessageActionsTabProps {
  isRead: boolean;
  onAction: (action: EmailMessageAction) => void;
}

const ACTIONS: { id: EmailMessageAction; label: string; icon: string; enabled: boolean; whenRead?: boolean }[] = [
  { id: 'reply', label: 'Reply', icon: '↩', enabled: true },
  { id: 'reply-all', label: 'Reply All', icon: '↩↩', enabled: true },
  { id: 'forward', label: 'Forward', icon: '➜', enabled: true },
  { id: 'move', label: 'Move to', icon: '📁', enabled: true },
  { id: 'mark-unread', label: 'Mark unread', icon: '●', enabled: true, whenRead: true },
  { id: 'delete', label: 'Delete', icon: '🗑', enabled: true }
];

const EmailMessageActionsTab: React.FC<EmailMessageActionsTabProps> = ({ isRead, onAction }) => {
  const visibleActions = ACTIONS.filter(action => !action.whenRead || isRead);

  return (
    <div className="email-message-actions" aria-label="Message actions">
      <div className="email-message-actions-tab">
        {visibleActions.map(action => (
          <button
            key={action.id}
            type="button"
            className="email-message-action-btn"
            title={action.label}
            disabled={!action.enabled}
            onClick={(e) => {
              e.stopPropagation();
              if (action.enabled) onAction(action.id);
            }}
          >
            <span className="email-message-action-icon" aria-hidden="true">{action.icon}</span>
            <span className="email-message-action-label">{action.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmailMessageActionsTab;
